import {
  BusinessLogFn,
  IMode,
  ISocialVendors,
  IdpConnection,
} from '../MemberLoginDialog.types';

export const INVISIBLE_CAPTCHA_SITE_KEY =
  '6LdoPaUfAAAAAJphvHoUoOob7mx0KDlXyXlgrx5v';
export const translationFeature = 'dialogMixinTranslations';
export const PASS_MIN_LEN = 4;
export const PASS_MAX_LEN = 100;
export const IDP_CONNECTION_IDS: Record<ISocialVendors, string> = {
  facebook: '3ecad13f-52c3-483d-911f-31dbcf2a6d23',
  google: '0e6a50f5-b523-4e29-990d-f37fa2ffdd69',
};
export const IGNORED_ERRORS = ['SOCIAL_LOGIN_CANCELLED_BY_USER'];

export const testIds = {
  socialAuth: 'socialAuth',
  emailAuth: 'emailAuth',
  socialAuthMessage: 'socialAuthMessage',
  copyLinkButton: 'copyLinkButton',
  switchToSignUp: 'switchToSignUp',
  switchToSignUpDescription: 'switchToSignUpDescription',
  forgotPasswordMobile: 'forgotPasswordMobile',
  forgotPasswordDesktop: 'forgotPasswordDesktop',
  switchToEmailLink: 'switchToEmailLink',
  submit: 'submit',
  googleMain: 'googlenew',
  googleSmall: 'googlenew-small',
  facebookMain: 'fbnew',
  facebookSmall: 'fbnew-small',
};

export const MemberLoginDialogTranslationKeys = {
  title: 'dialogMixinTranslation_log_in',
  submitButton: 'dialogMixinTranslations_log_in_btn_new',
  switchDialogLink: 'SMRegister_sign_up_new',
  mobileForgotPassword: 'dialogMixinTranslations_forgot_password_mobile_new',
  forgotPassword: 'dialogMixinTranslations_forgot_password',
  switchToSignUp: 'dialogMixinTranslations_switch_to_signup_material',
  socialSectionDivider: 'dialogMixinTranslations_or_log_in_with',
  emailSectionDivider: 'dialogMixinTranslations_or_email_new',
  inAppBrowserSocialAuth: (
    authMethod: 'signup' | 'login',
    socialMethod: 'google' | 'facebook' | 'googlefacebook',
  ) => {
    // e.g- To Login with Google or Facebook copy this page link and open it in another browser.
    return `dialogMixinTranslations_copy.${authMethod}.${socialMethod}`;
  },
  copyLinkText: 'dialogMixinTranslations_copy_link',
  password: {
    title: 'SMForm_Password',
    label: 'PasswordLogin_Password',
  },
  email: {
    title: 'SMForm_Email',
    label: 'SMForm_Email',
  },
  social: {
    iframeTitle: 'dialogMixinTranslations_social_login',
    google: {
      login: 'dialogMixinTranslations_login_google',
      signup: 'dialogMixinTranslations_signup_google',
    } as Record<IMode, string>,
    facebook: {
      login: 'dialogMixinTranslations_login_facebook',
      signup: 'dialogMixinTranslations_signup_facebook',
    } as Record<IMode, string>,
    sso: {
      login: 'dialogMixinTranslations_login_sso',
      signup: 'dialogMixinTranslations_signup_sso',
    },
  },
  switchToAuthWithEmail: 'dialogMixinTranslations_login_switch_email',
  linkCopied: 'dialogMixinTranslations_link_copied',
};

export const getReportCopyToClipboardBiCallback =
  (
    reportBi: BusinessLogFn,
    options: { biVisitorId: string; metaSiteId: string },
  ) =>
  () =>
    reportBi(
      {
        src: 5,
        evid: 1643,
        ...options,
      },
      { endpoint: 'site-members' },
    );

export const SM_ERROR_CODES = {
  CAPTCHA_REQUIRED: '19971',
  CAPTCHA_INVALID: '19970',
};

export function isFacebookEnabled(idps: Array<IdpConnection>): boolean {
  return idps.findIndex(idp => idp.name === 'Facebook') !== -1;
}

export function isGoogleEnabled(idps: Array<IdpConnection>): boolean {
  return idps.findIndex(idp => idp.name === 'Google') !== -1;
}
